<app-header></app-header>
<app-settings></app-settings>
<br />
<div>
  <app-melodies></app-melodies>
</div>
